import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from '@gemini/core';
export const BlockTitle = ({ children, as, }) => {
    return (_jsx(Box, { as: as !== null && as !== void 0 ? as : 'div', typography: {
            'breakpoint.base': 'typography.headline.24.bold',
            'breakpoint.lg': 'typography.headline.32.bold',
        }, whiteSpace: "pre-line", children: children }));
};
